import { call } from 'redux-saga/effects'
import { action as apiAction } from 'api/Api'

export default function * requestAddUserOwnerToUserGroup (action) {
  const { userId, userGroupId } = action.payload

  try {
    yield call(apiAction, 'AddUserOwningGroup', {
      groupId: userGroupId,
      owningUserId: userId,
    })
  } catch (error) {
    if (error.code !== 300) { // Duplicate
      throw error
    }
  }
}
